import { FeedItem } from './notification.model';

export function getNotificationSenderName(
  notification: Pick<FeedItem, 'senderName' | 'data'>,
  fallback = 'System',
): string {
  const candidates = [
    notification.senderName,
    notification.data?.['author'],
  ];

  return candidates
    .map(value => String(value ?? '').trim())
    .find(Boolean) || fallback;
}
